import React from "react";
import CustomerDetail from "views/Details/Index";
import Loans from "../Loans/Loans";
import Credit from "../Credit/Credit";
import PaymentLoanSummary from "views/Details/PaymentLoanSummary";
import Legal from "views/Customer/Legal";

const sectionStyle = {
  marginBottom: "28px",
};

// Payment lead full-view page for customers with payment_tran = true (merchant loans).
// Shows: Customer, Leads, Credit (KYC summary), Loan & Collection Summary, and Legal.
// The legacy wallet sections (Credit History, Wallet Limit Enhancement) were removed for V2.
const PaymentLead = () => {
  return (
    <div className="bg-lighter" style={{ padding: "24px 20px 100px 20px" }}>
      <section id="section-customer" style={sectionStyle}>
        <CustomerDetail />
      </section>

      <section id="section-leads" style={sectionStyle}>
        <Loans isPayment />
      </section>

      <section id="section-credit" style={sectionStyle}>
        <Credit summaryOnly />
      </section>

      <section id="section-loan-summary" style={sectionStyle}>
        <PaymentLoanSummary />
      </section>

      <section id="section-legal" style={sectionStyle}>
        <Legal />
      </section>
    </div>
  );
};

export default PaymentLead;
